// In-place typescript upgrade: This function is generic because the original implementation
// just returns the input if it is falsy or not a string, so we want to propagate that
// type in the return value
export function truncateStr<T>(str: T, charLength: number): T|string {
  if (str && typeof str === 'string') {
    return str.length > charLength ? `${str.substring(0, charLength - 3)}...` : str;
  }
  return str;
};
